import React, {Component} from 'react';
import Loading from '../loading';
import Paginator from './paginator';
import classnames from 'classnames';
import Icon from '../icon';
import PropTypes from 'prop-types';

export default class DataTable extends Component {

    static propTypes = {
        items: PropTypes.array.isRequired,
        config: PropTypes.shape({
            cols: PropTypes.arrayOf(PropTypes.shape({
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
                header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                sort_key: PropTypes.string,
                actions: PropTypes.bool
            })).isRequired,
            initialState: PropTypes.shape({
                order_field: PropTypes.string,
                order: PropTypes.oneOf(['asc', 'desc'])
            })
        }).isRequired,

        totalPages: PropTypes.number,
        currentPage: PropTypes.number,
        paginationAction: PropTypes.func,
        sortAction: PropTypes.func,
        clickable: PropTypes.func,


    };

    constructor(props) {
        super(props);
        const state = {
            order_field: '',
            order: 'asc',
            ...props.config.initialState,
        };
        this.state = state;
    }

    onItemClick(item) {
        if (this.props.clickable) {
            this.props.clickable(item);
        }
        return false;
    }

    changeSort(col) {
        let order = 'asc';
        if (this.state.order == 'asc') {
            order = 'desc';
        }
        const newSortOrder = {
            order_field: col.sort_key,
            order
        };
        this.setState(newSortOrder);
        if (this.props.sortAction) {
            this.props.sortAction(newSortOrder);
        }
    }

    renderHeaderItem(col) {
        if (col.sort_key) {
            const isSortableCol = col.sort_key === this.state.order_field;
            let orderIcon = <Icon icon="sort-up" size={'xs'}/>;
            if (this.state.order == 'desc') {
                orderIcon = <Icon icon="sort-down" size={'xs'}/>;
            }
            return (
                <div onClick={() => {
                    this.changeSort(col);
                }}>

                    {isSortableCol
                        ? orderIcon
                        : <Icon icon="sort-default" size={'xs'}/>}
                    {col.header}
                </div>
            );
        } else {
            return <div>{col.header}</div>;
        }
    }

    renderHeader(cols) {
        return cols.map((col, index) => {
            return (
                <th key={`header-${index}`} className={classnames(col.actions && 'actions-col')}>
                    {this.renderHeaderItem(col)}
                </th>
            );
        });
    }

    renderItemDisplay(item, itemIndex, col, index) {
        let valueDisplay = typeof col.value === 'function'
            ? col.value(item, itemIndex)
            : item[col.value];
        return (
            <td key={`table-col-${item.id}-${index}`}
                className={classnames(col.actions && 'actions-col')}>{valueDisplay}</td>
        );
    }

    render() {
        const {
            config,
            items,
            loading,
            responsive = true,
            className = '',
        } = this.props;
        if (loading) {
            return (<Loading/>);
        }
        return (
            <div className={classnames(responsive && 'responsive-table')}>
                <table className={classnames('table', className, responsive && 'responsive')}>
                    <thead>
                    <tr>
                        {this.renderHeader(config.cols)}
                    </tr>
                    </thead>
                    <tbody>
                    {items.map((item, itemIndex) => {
                        return (
                            <tr key={`table-item-${item.id || item.uuid || itemIndex}`}
                                onClick={this.onItemClick.bind(this, item)}>
                                {config.cols.map((col, index) => {
                                    return this.renderItemDisplay(item, itemIndex, col, index);
                                })
                                }
                            </tr>
                        );
                    })
                    }

                    </tbody>

                </table>

                <Paginator totalPages={this.props.totalPages} currentPage={this.props.page}
                           paginationAction={this.props.loadAction}/>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/js/components/data-table/data-table.jsx